import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeliveryAddress, EntitiesModel, ShipToFilterParams, ShipToPage } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ShipTosConnector {
  constructor(protected http: HttpClient, protected occEndpoints: OccEndpointsService) {}

  getShipTos(searchParams: ShipToFilterParams, userId: string): Observable<EntitiesModel<DeliveryAddress>> {
    const url = this.occEndpoints.buildUrl('availableShipTos', {
      urlParams: { userId: userId },
      queryParams: {
        page: searchParams.currentPage ?? 0,
        count: searchParams.pageSize ?? 10,
        search: searchParams.search,
        onlyConnected: searchParams?.onlyConnected,
        soldTos: searchParams?.soldTos,
        connectedToPermissionCode: searchParams?.connectedToPermissionCode,
        permissionCode: searchParams?.permissionCode,
        sort: searchParams.sort || undefined,
      },
    });
    return this.http.get<ShipToPage>(url).pipe(map((res) => ({ ...res, values: res.results })));
  }
}
